// takes an http response and gets the error message from it
export const selectErrorMessageFromResponse = (error) => {
  if (error === null) {
    return '';
  }

  let message = '';
  const response = error.response || error;

  if (response.hasOwnProperty('data')) {
    const { data } = response;

    if (data.hasOwnProperty('message')) message += data.message;

    if (data.hasOwnProperty('details')) message += (`: ${data.details}`);
  }

  if (message === '') return error.message;

  return message;
};
